import { createAction } from '@reduxjs/toolkit';

export type SupplierContentTranslationsTriggeredAction = ReturnType<
  typeof supplierContentTranslationsReady
>;

export const supplierContentTranslationsReady = createAction<string>(
  'supplierContentTranslationsReady',
);
